/** @format */

import {useState} from 'react';

import Alert from '@mui/material/Alert';

import {LinearProgress} from '@mui/material';

import {Trans} from 'react-i18next';

import {BillingDiscountPeriod} from 'graphql/generated/types';

import {SegmentedBox} from 'components/buttons/SegmentedGroup/SegmentedBox';

import {SegmentedRadioButton} from 'components/buttons/SegmentedGroup/SegmentedRadioButton';

import {ScreenLayout} from 'layouts/ScreenLayout';

import {ConstraintWidth, HeadingBox, HeadingText, MainContentBox, PurposeSwitchBox} from './styles';
import {Purpose} from './types';
import {BusinessTariffs} from './components/BusinessTariffs';
import {AgencyTariffs} from './components/AgencyTariffs';
import {useCardsData} from './hooks/useCardsData';
import {useGetBillingPricingQuery} from './graphql/__generated__';

const Tariffs = () => {
  const [purpose, setPurpose] = useState<Purpose>('business');
  const [duration, setDuration] = useState<BillingDiscountPeriod>('TWELVE_MONTHS');

  const {data, loading, error} = useGetBillingPricingQuery();

  const cardsData = useCardsData(data?.billingPricing.tariffs);
  const partnerDiscount = data?.billingPricing.partnerDiscount ?? null;

  if (error) {
    // eslint-disable-next-line no-console
    console.error(error.message);
    return (
      <Alert severity='error'>
        <Trans>Не удалось загрузить тарифы, попробуйте обновить страницу</Trans>
      </Alert>
    );
  }
  if (loading) {
    return <LinearProgress style={{flex: 1}} />;
  }

  return (
    <ScreenLayout>
      <ConstraintWidth>
        <HeadingBox>
          <HeadingText>
            <Trans>Выберите подходящий тариф для максимальной эффективности</Trans>
          </HeadingText>
        </HeadingBox>
      </ConstraintWidth>

      <ConstraintWidth>
        <PurposeSwitchBox>
          <SegmentedBox>
            <SegmentedRadioButton
              active={purpose === 'business'}
              onClick={() => setPurpose('business')}
              activeBgColor='linear-gradient(180deg, #316E9F 0%, #3E88C5 100%)'
              size='large'
            >
              <Trans>Для бизнеса</Trans>
            </SegmentedRadioButton>
            <SegmentedRadioButton
              active={purpose === 'agency'}
              onClick={() => setPurpose('agency')}
              activeBgColor='linear-gradient(180deg, #97526A 0%, #BB6784 100%)'
              size='large'
            >
              <Trans>Для агентства</Trans>
            </SegmentedRadioButton>
          </SegmentedBox>
        </PurposeSwitchBox>
      </ConstraintWidth>

      <MainContentBox>
        <ConstraintWidth>
          {purpose === 'business' && (
            <BusinessTariffs
              duration={duration}
              onChangeDuration={setDuration}
              cardsData={cardsData}
              partnerDiscount={partnerDiscount}
            />
          )}
          {purpose === 'agency' && <AgencyTariffs />}
        </ConstraintWidth>
      </MainContentBox>
    </ScreenLayout>
  );
};

export {Tariffs};
